<div>
    <app-icon ic="IcList" size="s" color="var(--color-primary-60)" (click)="listBtnAction()"></app-icon>
    <app-icon ic="IcVisible" size="s" color="var(--color-primary-60)"></app-icon>
    <app-icon ic="IcVisibleOff" size="s" color="var(--color-primary-60)"></app-icon>
</div>
